import {CadenceDetails} from './preview-step.types';
import {ReviewCard} from './review-card';

interface PreviewCadenceCardProps {
  details: CadenceDetails;
  onEdit?: () => void;
  cardVariant?: 'default' | 'detail';
}

export const PreviewCadenceCard = ({
  details,
  onEdit,
  cardVariant,
}: PreviewCadenceCardProps) => {
  return (
    <ReviewCard title="Cadence" onEdit={onEdit} variant={cardVariant}>
      <div className="flex flex-col gap-2">
        <CadenceRow label="Frequency" value={details.frequencyLabel} />
        {details.sendOnLabel && (
          <CadenceRow label="Day" value={details.sendOnLabel} />
        )}
        {details.timeLabel && (
          <CadenceRow label="Time" value={details.timeLabel} />
        )}
        {details.startLabel && (
          <CadenceRow label="Starts" value={details.startLabel} />
        )}
        {details.endLabel && (
          <CadenceRow label="Ends" value={details.endLabel} />
        )}
      </div>
    </ReviewCard>
  );
};

const CadenceRow = ({label, value}: {label: string; value: string}) => (
  <div className="flex items-start justify-between gap-6 text-sm leading-[22px]">
    <span className="shrink-0 font-medium text-textBody">{label}</span>
    <span className="break-words text-right text-blackTwo">{value || '—'}</span>
  </div>
);
